import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				display: "flex",
				border: `1px solid ${theme.palette.grey[200]}`,
				borderRadius: 4,
				padding: "5px 8px",
				marginBottom: 5,
				alignItems: "center",
				justifyContent: "space-between"
			},
			customImage: {
				display: "flex",
				alignItems: "center",
				"& > img": {
					width: 53,
					height: 53,
					marginRight: 5,
					objectFit: "contain"
				}
			},
			name: {
				fontSize: 12,
				color: theme.palette.primary.contrastText,
				fontWeight: 500
			},
			quantity: {
				width: 100,
				fontSize: 13,
				color: theme.palette.primary.contrastText,
				display: "flex",
				justifyContent: "space-between",
				fontWeight: 500
			}
		}),
	{
		name: "PromotionItem",
		index: 1
	}
);

export default useStyles;
